
import * as DocumentMappers from 'modules/document/mappers';
import * as Types from './types';

export const documentList = (items: Types.IApi.Document[]): Types.IEntity.Document[] => {
  return (items || []).map(item => document(item));
};

export const document = (item: Types.IApi.Document): Types.IEntity.Document => {
  return DocumentMappers.document(item as any);
};
